import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				padding: "10px 16px",
				width: "100%"
			},
			border: {
				borderTop: `1px dashed ${theme.palette.grey[800]}`,
				width: "100%",
				marginBottom: 10
			},
			btnPromotion: {
				background: theme.palette.grey[600],
				borderRadius: 2,
				fontSize: 12,
				display: "flex",
				alignItems: "center",
				justifyContent: "space-around",
				position: "relative",
				color: theme.palette.primary.contrastText,
				padding: 10,
				marginBottom: 5,
				width: "100%"
			},
			borderLeft: {
				width: 10,
				height: 10,
				position: "absolute",
				left: -5,
				borderRadius: "50%",
				background: theme.palette.common.white
			},
			borderRight: {
				width: 10,
				height: 10,
				position: "absolute",
				right: -5,
				borderRadius: "50%",
				background: theme.palette.common.white
			},
			promotion: {
				background:
					"linear-gradient(300.16deg, #F98C44 -1.36%, #F8BE1D 98.84%)",
				borderRadius: 4,
				padding: "5px 10px",
				textAlign: "center",
				color: theme.palette.common.white,
				fontWeight: 500
			},
			discount: {
				background:
					"linear-gradient(96.52deg, #0F8FB7 1.22%, #46C8DA 132.79%, #2925E8 213.84%, #E83025 242.78%)",
				borderRadius: 4,
				padding: "5px 10px",
				textAlign: "center",
				color: theme.palette.common.white,
				fontWeight: 500
			},
			titleDiscount: {
				color: theme.palette.grey[50],
				fontSize: 12,
				width: "100%",
				padding: "10px 0px",
				display: "flex",
				justifyContent: "center",
				alignItems: "center"
			},
			title: {
				width: 220,
				textAlign: "center"
			},
			line: {
				borderTop: `1px dashed ${theme.palette.grey[800]}`,
				width: "calc((100% - 220px)/2)"
			},
			promotionDetail: {
				textAlign: "center",
				fontSize: 12,
				color: theme.palette.secondary.main,
				padding: 5,
				width: "100%",
				"&:active": {
					opacity: 0.7,
					cursor: "pointer"
				}
			},
			note: {
				background: theme.palette.primary.dark,
				fontSize: 12,
				color: theme.palette.primary.contrastText,
				textAlign: "center",
				borderRadius: 20,
				padding: 3,
				width: "100%",
				margin: "10px 0px"
			}
		}),
	{
		name: "BoughtRecentlyFooter",
		index: 1
	}
);

export default useStyles;
